import lodash from "lodash"
import Vue from "vue"
import Router from "vue-router"
import Home from "@/Home/Home"
import AccessDenied from "@/Home/AccessDenied"
import PreIngestHome from "@/PreIngest/PreIngestHome"
import XMLBHome from "@/XMLBacklog/XMLBacklogHome"
import AssetStatusHome from "@/AssetStatus/AssetStatusHome"
import ProviderGroupsHome from "@/Providers/ProviderGroups/ProviderGroupsHome"
import ProviderListHome from "@/Providers/ProviderList/ProviderListHome"
import MetadataRulesHome from "@/MetadataRules/MetadataRulesHome"
import MetadataRulesSearch from "@/MetadataRules/MetadataRulesSearch"
import XPathMappingHome from "@/MetadataRules/XpathMapping/XPathMappingHome"
import ManageRule from "@/MetadataRules/Rule/ManageRule"
import ManageRuleSet from "@/MetadataRules/RuleSet/ManageRuleSet"
import ManageRuleCollection from "@/MetadataRules/RuleCollection/ManageRuleCollection"
import ConfigServiceHome from "@/ConfigService/ConfigServiceHome"
import XVATHome from "@/XVAT/XVATHome"
import XVATRulesSearch from "@/XVAT/XVATRulesSearch"
import XVATXPathMappingHome from "@/XVAT/XpathMapping/XVATXPathMappingHome"
import XVATManageRule from "@/XVAT/Rule/XVATManageRule"
import XVATManageRuleSet from "@/XVAT/RuleSet/XVATManageRuleSet"
import XVATManageRuleCollection from "@/XVAT/RuleCollection/XVATManageRuleCollection"
import SSO from "@/Auth/SSO"
import MPXLogin from "@/Auth/MPXLogin"
import MPXAccountSelection from "@/Auth/MPXAccountSelection"
import AppService from "@/AppService"
import * as appDataService from "@/AppDataService"
import store from "@/store/index.js"
import {
  GET_MPX_USER_INFO,
  GET_CABLE_USER_INFO,
  GET_MVATS_AUTHORIZE_INFO,
  GET_OPSUI_AUTHORIZE_INFO,
  GET_MPX_PARENT_ACCOUNT,
  GET_MPX_SERVICE_REGISTRY,
  GET_MPX_SUB_ACCOUNTS
} from "@/store/constants/action-types"
import * as authDataService from "@/Auth/AuthDataService"

Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
      beforeEnter: (to, from, next) => {
        updateMPXUserInfo()
          .then(() => {
            return udpateCableUserInfo()
          })
          .then(() => {
            next()
          })
      }
    },
    {
      path: "/xml-backlog",
      name: "XMLBacklog",
      component: XMLBHome,
      beforeEnter: (to, from, next) => {
        validateCableAccess(to, from, next)
      }
    },
    {
      path: "/pre-ingest",
      name: "PreIngestHome",
      component: PreIngestHome,
      beforeEnter: (to, from, next) => {
        validateMPXAccess(to, from, next)
      }
    },
    {
      path: "/providers/provider-list",
      name: "ProviderListHome",
      component: ProviderListHome,
      beforeEnter: (to, from, next) => {
        validateMPXAccess(to, from, next)
      }
    },
    {
      path: "/providers/provider-groups",
      name: "ProviderGroupsHome",
      component: ProviderGroupsHome,
      beforeEnter: (to, from, next) => {
        validateMPXAccess(to, from, next)
      }
    },
    {
      path: "/metadata-rules",
      component: MetadataRulesHome,
      beforeEnter: (to, from, next) => {
        validateMPXAccess(to, from, next)
      },
      children: [
        {
          path: "",
          name: "MetadataRulesSearch",
          component: MetadataRulesSearch
        },
        {
          path: "xpath-mapping",
          name: "XPathMappingHome",
          component: XPathMappingHome
        },
        {
          path: "rule/:id?",
          name: "ManageRule",
          component: ManageRule
        },
        {
          path: "rule-set/:id?",
          name: "ManageRuleSet",
          component: ManageRuleSet
        },
        {
          path: "rule-collection/:id?",
          name: "ManageRuleCollection",
          component: ManageRuleCollection
        }
      ]
    },
    {
      path: "/config-service",
      name: "ConfigServiceHome",
      component: ConfigServiceHome,
      beforeEnter: (to, from, next) => {
        validateCableAccess(to, from, next)
      }
    },
    {
      path: "/xvat",
      component: XVATHome,
      beforeEnter: (to, from, next) => {
        validateCableAccess(to, from, next)
      },
      children: [
        {
          path: "",
          name: "XVATRulesSearch",
          component: XVATRulesSearch
        },
        {
          path: "xpath-mapping",
          name: "XVATXPathMappingHome",
          component: XVATXPathMappingHome
        },
        {
          path: "rule/:id?",
          name: "XVATManageRule",
          component: XVATManageRule
        },
        {
          path: "rule-set/:id?",
          name: "XVATManageRuleSet",
          component: XVATManageRuleSet
        },
        {
          path: "rule-collection/:id?",
          name: "XVATManageRuleCollection",
          component: XVATManageRuleCollection
        }
      ]
    },
    {
      path: "/asset-status",
      name: "AssetStatusHome",
      component: AssetStatusHome
    },
    {
      path: "/sso",
      name: "SSO",
      component: SSO
    },
    {
      path: "/mpx-login",
      name: "MPXLogin",
      component: MPXLogin,
      beforeEnter: (to, from, next) => {
        validateMPXAccess(to, from, next)
      }
    },
    {
      path: "/select-account",
      name: "MPXAccountSelection",
      component: MPXAccountSelection,
      beforeEnter: (to, from, next) => {
        validateMPXAccess(to, from, next)
      }
    },
    {
      path: "/access-denied",
      name: "AccessDenied",
      component: AccessDenied
    },
    /* {
      path: "*",
      redirect: "/"
    } */
    {
      path: "/:catchAll(.*)",
      component: AccessDenied,
      name: "NotFound"
    }
  ]
})

/**
 * validateMPXAccess - validate if the user has logged in with MPX credentials
 * @param {*} to
 * @param {*} from
 * @param {*} next
 */
function validateMPXAccess(to, from, next) {
  if (to.name === "MPXLogin") {
    if (to.query && to.query.token === "false") {
      next()
    } else {
      AppService.isSignedIntoMPX()
        .then(() => {
          // NOTE: Read data from local storage and store in 'vuex' store
          updateMPXUserInfo().then(() => {
            // If the user is trying to go back to MPX login, redirect to Pre Ingest Home
            next({
              name: "PreIngestHome"
            })
          })
        })
        .catch(() => {
          next()
        })
        .finally(() => {
          udpateCableUserInfo() // Update Cable user if exists
        })
    }
  } else {
    AppService.isSignedIntoMPX()
      .then(() => {
        updateMPXUserInfo().then(() => {
          if (to.name === "MPXAccountSelection") {
            next()
          } else if (lodash.isEmpty(store.state.mpxParentAccount)) {
            next({
              name: "MPXAccountSelection",
              query: {
                redirect: to.fullPath
              }
            })
          } else {
            if (
              !AppService.hasAccessToMPXView(
                store.state.mpxParentAccount._service,
                to.path
              )
            ) {
              next({
                name: "AccessDenied"
              })
            } else {
              next()
            }
          }
        })
      })
      .catch(() => {
        next({
          name: "MPXLogin",
          query: {
            redirect: to.fullPath
          }
        })
      })
      .finally(() => {
        udpateCableUserInfo() // Update Cable user if exists
      })
  }
}

/**
 * validateCableAccess - Validate if the user has logged in with CABLE credentials
 * @param {*} to
 * @param {*} from
 * @param {*} next
 */
function validateCableAccess(to, from, next) {
  const toPathName = to.name
  AppService.isSignedIntoCable()
    .then(() => {
      // NOTE: Read data from local storage and store in 'vuex' store
      udpateCableUserInfo().then(() => {
        next()
      })
    })
    .catch(() => {
      appDataService.setRedirectPath(toPathName)
      authDataService.getWebSecUrl().then((authorizationUrl) => {
        window.location.href = authorizationUrl
      })
      next(false)
    })
    .finally(() => {
      udpateCableUserInfo() // Update MPX user if exists
    })
}

/**
 * updateMPXUserInfo - update store with mpx user info
 */
function updateMPXUserInfo() {
  // ENSURES THAT USER DATA IS AVAILABLE IN STORE
  return Promise.all([
    store.dispatch(GET_MPX_USER_INFO),
    store.dispatch(GET_MVATS_AUTHORIZE_INFO),
    store.dispatch(GET_OPSUI_AUTHORIZE_INFO),
    store.dispatch(GET_MPX_PARENT_ACCOUNT),
    store.dispatch(GET_MPX_SERVICE_REGISTRY),
    store.dispatch(GET_MPX_SUB_ACCOUNTS)
  ])
}

/**
 * udpateCableUserInfo - Update store with cable user info
 */
function udpateCableUserInfo() {
  return store.dispatch(GET_CABLE_USER_INFO)
}



// WEBPACK FOOTER //
// ./src/router/index.js